import { translations } from './translations';

export const getTranslation = (language, key) => {
    return translations[language]?.[key] || translations.en[key] || key;
};
